/* tslint:disable */

import { ConcreteRequest } from "relay-runtime";
export type PreviewKind = "A_ROLE" | "BACKGROUND" | "BADGE_DARK" | "BADGE_LIGHT" | "B_ROLE" | "CAROUSEL" | "DETAIL_BACKGROUND" | "EXCERPT" | "HEADSHOT" | "HERO" | "HERO_LOGO" | "LOGO" | "PORTRAIT" | "SQUARE" | "%future added value";
export type TopLevelMediaKind = "APPLICATION" | "AUDIO" | "DOCUMENT" | "IMAGE" | "TEXT" | "VIDEO" | "%future added value";
export type companiesAndOrganizationsMoreQueryVariables = {
    readonly listId: string;
    readonly count?: number | null;
};
export type companiesAndOrganizationsMoreQueryResponse = {
    readonly list: {
        readonly hasErrors: boolean | null;
        readonly list: ({
            readonly __typename: string;
            readonly description?: string | null;
            readonly id?: string;
            readonly items?: {
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly listItem: {
                        readonly item: ({
                            readonly __typename: string;
                            readonly label: string | null;
                            readonly subTitle: string | null;
                            readonly title: string | null;
                            readonly description?: string | null;
                            readonly hasPublicPage?: boolean | null;
                            readonly id?: string;
                            readonly name?: string | null;
                            readonly landingPageUrl?: string | null;
                            readonly previews?: {
                                readonly count: number | null;
                                readonly edges: ReadonlyArray<{
                                    readonly cursor: string | null;
                                    readonly preview: {
                                        readonly mediaAsset: {
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly path: string | null;
                                            }> | null;
                                            readonly topLevelMediaType: {
                                                readonly kind: TopLevelMediaKind | null;
                                                readonly label: string | null;
                                            } | null;
                                        } | null;
                                        readonly link: string | null;
                                        readonly kind: PreviewKind | null;
                                    } | null;
                                }> | null;
                            } | null;
                            readonly fullName?: string | null;
                            readonly responsibility?: string | null;
                            readonly kind?: string | null;
                            readonly linkUrl?: string | null;
                            readonly previewUrl?: string | null;
                            readonly publisher?: string | null;
                            readonly tags?: ReadonlyArray<string> | null;
                        } & ({
                            readonly __typename: "Entity";
                            readonly description: string | null;
                            readonly hasPublicPage: boolean | null;
                            readonly id: string;
                            readonly name: string | null;
                            readonly landingPageUrl: string | null;
                            readonly previews: {
                                readonly count: number | null;
                                readonly edges: ReadonlyArray<{
                                    readonly cursor: string | null;
                                    readonly preview: {
                                        readonly mediaAsset: {
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly path: string | null;
                                            }> | null;
                                            readonly topLevelMediaType: {
                                                readonly kind: TopLevelMediaKind | null;
                                                readonly label: string | null;
                                            } | null;
                                        } | null;
                                        readonly link: string | null;
                                        readonly kind: PreviewKind | null;
                                    } | null;
                                }> | null;
                            } | null;
                        } | {
                            readonly __typename: "Person";
                            readonly fullName: string | null;
                            readonly responsibility: string | null;
                        } | {
                            readonly __typename: "SearchHit";
                            readonly kind?: string | null;
                            readonly linkUrl?: string | null;
                            readonly previewUrl?: string | null;
                            readonly publisher?: string | null;
                            readonly tags?: ReadonlyArray<string> | null;
                        } | {
                            /*This will never be '% other', but we need some
                            value in case none of the concrete values match.*/
                            readonly __typename: "%other";
                        })) | null;
                    } | null;
                }> | null;
                readonly filter?: {
                    readonly keys: ReadonlyArray<string> | null;
                    readonly filter: ReadonlyArray<{
                        readonly key: string;
                        readonly ids: ReadonlyArray<string> | null;
                    }> | null;
                } | null;
            } | null;
            readonly label?: string | null;
            readonly name?: string | null;
            readonly previews?: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly preview: {
                        readonly link: string | null;
                        readonly kind: PreviewKind | null;
                        readonly mediaAsset: {
                            readonly id: string;
                            readonly files: ReadonlyArray<{
                                readonly name: string | null;
                                readonly path: string | null;
                                readonly id?: string;
                            }> | null;
                            readonly topLevelMediaType: {
                                readonly kind: TopLevelMediaKind | null;
                                readonly label: string | null;
                            } | null;
                        } | null;
                    } | null;
                }> | null;
            } | null;
            readonly subTitle?: string | null;
            readonly title?: string | null;
        } & ({
            readonly __typename: "FixedList";
            readonly description: string | null;
            readonly id: string;
            readonly items: {
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly listItem: {
                        readonly item: ({
                            readonly __typename: string;
                            readonly label: string | null;
                            readonly subTitle: string | null;
                            readonly title: string | null;
                            readonly description?: string | null;
                            readonly hasPublicPage?: boolean | null;
                            readonly id?: string;
                            readonly name?: string | null;
                            readonly landingPageUrl?: string | null;
                            readonly previews?: {
                                readonly count: number | null;
                                readonly edges: ReadonlyArray<{
                                    readonly cursor: string | null;
                                    readonly preview: {
                                        readonly mediaAsset: {
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly path: string | null;
                                            }> | null;
                                            readonly topLevelMediaType: {
                                                readonly kind: TopLevelMediaKind | null;
                                                readonly label: string | null;
                                            } | null;
                                        } | null;
                                        readonly link: string | null;
                                        readonly kind: PreviewKind | null;
                                    } | null;
                                }> | null;
                            } | null;
                            readonly fullName?: string | null;
                            readonly responsibility?: string | null;
                            readonly kind?: string | null;
                            readonly linkUrl?: string | null;
                            readonly previewUrl?: string | null;
                            readonly publisher?: string | null;
                            readonly tags?: ReadonlyArray<string> | null;
                        } & ({
                            readonly __typename: "Entity";
                            readonly description: string | null;
                            readonly hasPublicPage: boolean | null;
                            readonly id: string;
                            readonly name: string | null;
                            readonly landingPageUrl: string | null;
                            readonly previews: {
                                readonly count: number | null;
                                readonly edges: ReadonlyArray<{
                                    readonly cursor: string | null;
                                    readonly preview: {
                                        readonly mediaAsset: {
                                            readonly files: ReadonlyArray<{
                                                readonly id: string;
                                                readonly name: string | null;
                                                readonly path: string | null;
                                            }> | null;
                                            readonly topLevelMediaType: {
                                                readonly kind: TopLevelMediaKind | null;
                                                readonly label: string | null;
                                            } | null;
                                        } | null;
                                        readonly link: string | null;
                                        readonly kind: PreviewKind | null;
                                    } | null;
                                }> | null;
                            } | null;
                        } | {
                            readonly __typename: "Person";
                            readonly fullName: string | null;
                            readonly responsibility: string | null;
                        } | {
                            readonly __typename: "SearchHit";
                            readonly kind?: string | null;
                            readonly linkUrl?: string | null;
                            readonly previewUrl?: string | null;
                            readonly publisher?: string | null;
                            readonly tags?: ReadonlyArray<string> | null;
                        } | {
                            /*This will never be '% other', but we need some
                            value in case none of the concrete values match.*/
                            readonly __typename: "%other";
                        })) | null;
                    } | null;
                }> | null;
                readonly filter?: {
                    readonly keys: ReadonlyArray<string> | null;
                    readonly filter: ReadonlyArray<{
                        readonly key: string;
                        readonly ids: ReadonlyArray<string> | null;
                    }> | null;
                } | null;
            } | null;
            readonly label: string | null;
            readonly name: string | null;
            readonly previews: {
                readonly count: number | null;
                readonly edges: ReadonlyArray<{
                    readonly cursor: string | null;
                    readonly preview: {
                        readonly link: string | null;
                        readonly kind: PreviewKind | null;
                        readonly mediaAsset: {
                            readonly id: string;
                            readonly files: ReadonlyArray<{
                                readonly name: string | null;
                                readonly path: string | null;
                                readonly id?: string;
                            }> | null;
                            readonly topLevelMediaType: {
                                readonly kind: TopLevelMediaKind | null;
                                readonly label: string | null;
                            } | null;
                        } | null;
                    } | null;
                }> | null;
            } | null;
            readonly subTitle: string | null;
            readonly title: string | null;
        } | {
            /*This will never be '% other', but we need some
            value in case none of the concrete values match.*/
            readonly __typename: "%other";
        })) | null;
    } | null;
};
export type companiesAndOrganizationsMoreQuery = {
    readonly response: companiesAndOrganizationsMoreQueryResponse;
    readonly variables: companiesAndOrganizationsMoreQueryVariables;
};



/*
query companiesAndOrganizationsMoreQuery(
  $listId: ID!
  $count: Int
) {
  list(id: $listId) {
    hasErrors
    list {
      __typename
      ... on FixedList {
        description
        id
        items {
          edges {
            cursor
            listItem {
              item {
                __typename
                ... on Entity {
                  description
                  hasPublicPage
                  id
                  name
                  landingPageUrl
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        mediaAsset {
                          files {
                            id
                            name
                            path
                          }
                          topLevelMediaType {
                            kind
                            label
                            id
                          }
                          id
                        }
                        link
                        kind
                      }
                    }
                  }
                }
                ... on Person {
                  hasPublicPage
                  id
                  fullName
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        mediaAsset {
                          files {
                            id
                            name
                            path
                          }
                          topLevelMediaType {
                            kind
                            label
                            id
                          }
                          id
                        }
                        link
                        kind
                      }
                    }
                  }
                  landingPageUrl
                  responsibility
                }
                ... on Story {
                  description
                  label
                  previews {
                    count
                    edges {
                      cursor
                      preview {
                        mediaAsset {
                          files {
                            id
                            name
                            path
                          }
                          topLevelMediaType {
                            kind
                            label
                            id
                          }
                          id
                        }
                        link
                        kind
                      }
                    }
                  }
                  subTitle
                  title
                }
                ... on Node {
                  id
                }
                ... on SearchHit {
                  id
                }
                ... on Tag {
                  id
                }
              }
              id
            }
          }
        }
        label
        name
        previews {
          count
          edges {
            cursor
            preview {
              link
              kind
              mediaAsset {
                id
                files {
                  name
                  path
                  id
                }
                topLevelMediaType {
                  kind
                  label
                  id
                }
              }
            }
          }
        }
        subTitle
        title
      }
      ... on DynamicList {
        description
        id
        label
        name
        items(first: $count) {
          edges {
            cursor
            listItem {
              item {
                __typename
                ... on SearchHit {
                  id
                  kind
                  label
                  linkUrl
                  landingPageUrl
                  name
                  previewUrl
                  publisher
                  responsibility
                  subTitle
                  title
                  tags
                }
                ... on Node {
                  id
                }
                ... on Tag {
                  id
                }
              }
              id
            }
          }
          filter {
            keys
            filter {
              key
              ids
            }
          }
        }
        previews {
          count
          edges {
            cursor
            preview {
              mediaAsset {
                files {
                  id
                  name
                  path
                }
                topLevelMediaType {
                  kind
                  label
                  id
                }
                id
              }
              link
              kind
            }
          }
        }
        subTitle
        title
      }
      ... on Node {
        id
      }
    }
  }
}
*/

const node: ConcreteRequest = (function(){
var v0 = [
  {
    "kind": "LocalArgument",
    "name": "listId",
    "type": "ID!",
    "defaultValue": null
  },
  {
    "kind": "LocalArgument",
    "name": "count",
    "type": "Int",
    "defaultValue": null
  }
],
v1 = [
  {
    "kind": "Variable",
    "name": "id",
    "variableName": "listId"
  }
],
v2 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasErrors",
  "args": null,
  "storageKey": null
},
v3 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "__typename",
  "args": null,
  "storageKey": null
},
v4 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "description",
  "args": null,
  "storageKey": null
},
v5 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "id",
  "args": null,
  "storageKey": null
},
v6 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "cursor",
  "args": null,
  "storageKey": null
},
v7 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "label",
  "args": null,
  "storageKey": null
},
v8 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "count",
  "args": null,
  "storageKey": null
},
v9 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "name",
  "args": null,
  "storageKey": null
},
v10 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "path",
  "args": null,
  "storageKey": null
},
v11 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "files",
  "storageKey": null,
  "args": null,
  "concreteType": "MediaAssetFile",
  "plural": true,
  "selections": [
    (v5/*: any*/),
    (v9/*: any*/),
    (v10/*: any*/)
  ]
},
v12 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "kind",
  "args": null,
  "storageKey": null
},
v13 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v7/*: any*/)
  ]
},
v14 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "link",
  "args": null,
  "storageKey": null
},
v15 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v13/*: any*/)
              ]
            },
            (v14/*: any*/),
            (v12/*: any*/)
          ]
        }
      ]
    }
  ]
},
v16 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "subTitle",
  "args": null,
  "storageKey": null
},
v17 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "title",
  "args": null,
  "storageKey": null
},
v18 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "hasPublicPage",
  "args": null,
  "storageKey": null
},
v19 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "landingPageUrl",
  "args": null,
  "storageKey": null
},
v20 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "fullName",
  "args": null,
  "storageKey": null
},
v21 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "responsibility",
  "args": null,
  "storageKey": null
},
v22 = [
  {
    "kind": "Variable",
    "name": "first",
    "variableName": "count"
  }
],
v23 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "linkUrl",
  "args": null,
  "storageKey": null
},
v24 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "previewUrl",
  "args": null,
  "storageKey": null
},
v25 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "publisher",
  "args": null,
  "storageKey": null
},
v26 = {
  "kind": "ScalarField",
  "alias": null,
  "name": "tags",
  "args": null,
  "storageKey": null
},
v27 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "filter",
  "storageKey": null,
  "args": null,
  "concreteType": "ListFilter",
  "plural": false,
  "selections": [
    {
      "kind": "ScalarField",
      "alias": null,
      "name": "keys",
      "args": null,
      "storageKey": null
    },
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "filter",
      "storageKey": null,
      "args": null,
      "concreteType": "FilterItem",
      "plural": true,
      "selections": [
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "key",
          "args": null,
          "storageKey": null
        },
        {
          "kind": "ScalarField",
          "alias": null,
          "name": "ids",
          "args": null,
          "storageKey": null
        }
      ]
    }
  ]
},
v28 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "topLevelMediaType",
  "storageKey": null,
  "args": null,
  "concreteType": "TopLevelMediaType",
  "plural": false,
  "selections": [
    (v12/*: any*/),
    (v7/*: any*/),
    (v5/*: any*/)
  ]
},
v29 = {
  "kind": "LinkedField",
  "alias": null,
  "name": "previews",
  "storageKey": null,
  "args": null,
  "concreteType": "PreviewsConnection",
  "plural": false,
  "selections": [
    (v8/*: any*/),
    {
      "kind": "LinkedField",
      "alias": null,
      "name": "edges",
      "storageKey": null,
      "args": null,
      "concreteType": "PreviewEdge",
      "plural": true,
      "selections": [
        (v6/*: any*/),
        {
          "kind": "LinkedField",
          "alias": null,
          "name": "preview",
          "storageKey": null,
          "args": null,
          "concreteType": "Preview",
          "plural": false,
          "selections": [
            {
              "kind": "LinkedField",
              "alias": null,
              "name": "mediaAsset",
              "storageKey": null,
              "args": null,
              "concreteType": "MediaAsset",
              "plural": false,
              "selections": [
                (v11/*: any*/),
                (v28/*: any*/),
                (v5/*: any*/)
              ]
            },
            (v14/*: any*/),
            (v12/*: any*/)
          ]
        }
      ]
    }
  ]
};
return {
  "kind": "Request",
  "fragment": {
    "kind": "Fragment",
    "name": "companiesAndOrganizationsMoreQuery",
    "type": "Query",
    "metadata": null,
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "list",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "list",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v3/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "FixedList",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ListItemsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItemEdge",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "listItem",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItem",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v7/*: any*/),
                                  (v15/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Entity",
                                    "selections": [
                                      (v18/*: any*/),
                                      (v5/*: any*/),
                                      (v9/*: any*/),
                                      (v19/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Person",
                                    "selections": [
                                      (v18/*: any*/),
                                      (v5/*: any*/),
                                      (v20/*: any*/),
                                      (v19/*: any*/),
                                      (v21/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v7/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "previews",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PreviewsConnection",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PreviewEdge",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "preview",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Preview",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "mediaAsset",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MediaAsset",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "files",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MediaAssetFile",
                                    "plural": true,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v10/*: any*/)
                                    ]
                                  },
                                  (v13/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v16/*: any*/),
                  (v17/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "DynamicList",
                "selections": [
                  (v4/*: any*/),
                  (v5/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": (v22/*: any*/),
                    "concreteType": "ListItemsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItemEdge",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "listItem",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItem",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "type": "SearchHit",
                                    "selections": [
                                      (v5/*: any*/),
                                      (v12/*: any*/),
                                      (v7/*: any*/),
                                      (v23/*: any*/),
                                      (v19/*: any*/),
                                      (v9/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v21/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/),
                                      (v26/*: any*/)
                                    ]
                                  }
                                ]
                              }
                            ]
                          }
                        ]
                      },
                      (v27/*: any*/)
                    ]
                  },
                  (v15/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "operation": {
    "kind": "Operation",
    "name": "companiesAndOrganizationsMoreQuery",
    "argumentDefinitions": (v0/*: any*/),
    "selections": [
      {
        "kind": "LinkedField",
        "alias": null,
        "name": "list",
        "storageKey": null,
        "args": (v1/*: any*/),
        "concreteType": "ListPayload",
        "plural": false,
        "selections": [
          (v2/*: any*/),
          {
            "kind": "LinkedField",
            "alias": null,
            "name": "list",
            "storageKey": null,
            "args": null,
            "concreteType": null,
            "plural": false,
            "selections": [
              (v3/*: any*/),
              (v5/*: any*/),
              {
                "kind": "InlineFragment",
                "type": "FixedList",
                "selections": [
                  (v4/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "ListItemsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItemEdge",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "listItem",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItem",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v4/*: any*/),
                                  (v7/*: any*/),
                                  (v29/*: any*/),
                                  (v16/*: any*/),
                                  (v17/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Entity",
                                    "selections": [
                                      (v18/*: any*/),
                                      (v9/*: any*/),
                                      (v19/*: any*/)
                                    ]
                                  },
                                  {
                                    "kind": "InlineFragment",
                                    "type": "Person",
                                    "selections": [
                                      (v18/*: any*/),
                                      (v20/*: any*/),
                                      (v19/*: any*/),
                                      (v21/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v5/*: any*/)
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v7/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "previews",
                    "storageKey": null,
                    "args": null,
                    "concreteType": "PreviewsConnection",
                    "plural": false,
                    "selections": [
                      (v8/*: any*/),
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "PreviewEdge",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "preview",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "Preview",
                            "plural": false,
                            "selections": [
                              (v14/*: any*/),
                              (v12/*: any*/),
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "mediaAsset",
                                "storageKey": null,
                                "args": null,
                                "concreteType": "MediaAsset",
                                "plural": false,
                                "selections": [
                                  (v5/*: any*/),
                                  {
                                    "kind": "LinkedField",
                                    "alias": null,
                                    "name": "files",
                                    "storageKey": null,
                                    "args": null,
                                    "concreteType": "MediaAssetFile",
                                    "plural": true,
                                    "selections": [
                                      (v9/*: any*/),
                                      (v10/*: any*/),
                                      (v5/*: any*/)
                                    ]
                                  },
                                  (v28/*: any*/)
                                ]
                              }
                            ]
                          }
                        ]
                      }
                    ]
                  },
                  (v16/*: any*/),
                  (v17/*: any*/)
                ]
              },
              {
                "kind": "InlineFragment",
                "type": "DynamicList",
                "selections": [
                  (v4/*: any*/),
                  (v7/*: any*/),
                  (v9/*: any*/),
                  {
                    "kind": "LinkedField",
                    "alias": null,
                    "name": "items",
                    "storageKey": null,
                    "args": (v22/*: any*/),
                    "concreteType": "ListItemsConnection",
                    "plural": false,
                    "selections": [
                      {
                        "kind": "LinkedField",
                        "alias": null,
                        "name": "edges",
                        "storageKey": null,
                        "args": null,
                        "concreteType": "ListItemEdge",
                        "plural": true,
                        "selections": [
                          (v6/*: any*/),
                          {
                            "kind": "LinkedField",
                            "alias": null,
                            "name": "listItem",
                            "storageKey": null,
                            "args": null,
                            "concreteType": "ListItem",
                            "plural": false,
                            "selections": [
                              {
                                "kind": "LinkedField",
                                "alias": null,
                                "name": "item",
                                "storageKey": null,
                                "args": null,
                                "concreteType": null,
                                "plural": false,
                                "selections": [
                                  (v3/*: any*/),
                                  (v5/*: any*/),
                                  {
                                    "kind": "InlineFragment",
                                    "type": "SearchHit",
                                    "selections": [
                                      (v12/*: any*/),
                                      (v7/*: any*/),
                                      (v23/*: any*/),
                                      (v19/*: any*/),
                                      (v9/*: any*/),
                                      (v24/*: any*/),
                                      (v25/*: any*/),
                                      (v21/*: any*/),
                                      (v16/*: any*/),
                                      (v17/*: any*/),
                                      (v26/*: any*/)
                                    ]
                                  }
                                ]
                              },
                              (v5/*: any*/)
                            ]
                          }
                        ]
                      },
                      (v27/*: any*/)
                    ]
                  },
                  (v29/*: any*/),
                  (v16/*: any*/),
                  (v17/*: any*/)
                ]
              }
            ]
          }
        ]
      }
    ]
  },
  "params": {
    "operationKind": "query",
    "name": "companiesAndOrganizationsMoreQuery",
    "id": null,
    "text": "query companiesAndOrganizationsMoreQuery(\n  $listId: ID!\n  $count: Int\n) {\n  list(id: $listId) {\n    hasErrors\n    list {\n      __typename\n      ... on FixedList {\n        description\n        id\n        items {\n          edges {\n            cursor\n            listItem {\n              item {\n                __typename\n                ... on Entity {\n                  description\n                  hasPublicPage\n                  id\n                  name\n                  landingPageUrl\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        mediaAsset {\n                          files {\n                            id\n                            name\n                            path\n                          }\n                          topLevelMediaType {\n                            kind\n                            label\n                            id\n                          }\n                          id\n                        }\n                        link\n                        kind\n                      }\n                    }\n                  }\n                }\n                ... on Person {\n                  hasPublicPage\n                  id\n                  fullName\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        mediaAsset {\n                          files {\n                            id\n                            name\n                            path\n                          }\n                          topLevelMediaType {\n                            kind\n                            label\n                            id\n                          }\n                          id\n                        }\n                        link\n                        kind\n                      }\n                    }\n                  }\n                  landingPageUrl\n                  responsibility\n                }\n                ... on Story {\n                  description\n                  label\n                  previews {\n                    count\n                    edges {\n                      cursor\n                      preview {\n                        mediaAsset {\n                          files {\n                            id\n                            name\n                            path\n                          }\n                          topLevelMediaType {\n                            kind\n                            label\n                            id\n                          }\n                          id\n                        }\n                        link\n                        kind\n                      }\n                    }\n                  }\n                  subTitle\n                  title\n                }\n                ... on Node {\n                  id\n                }\n                ... on SearchHit {\n                  id\n                }\n                ... on Tag {\n                  id\n                }\n              }\n              id\n            }\n          }\n        }\n        label\n        name\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              link\n              kind\n              mediaAsset {\n                id\n                files {\n                  name\n                  path\n                  id\n                }\n                topLevelMediaType {\n                  kind\n                  label\n                  id\n                }\n              }\n            }\n          }\n        }\n        subTitle\n        title\n      }\n      ... on DynamicList {\n        description\n        id\n        label\n        name\n        items(first: $count) {\n          edges {\n            cursor\n            listItem {\n              item {\n                __typename\n                ... on SearchHit {\n                  id\n                  kind\n                  label\n                  linkUrl\n                  landingPageUrl\n                  name\n                  previewUrl\n                  publisher\n                  responsibility\n                  subTitle\n                  title\n                  tags\n                }\n                ... on Node {\n                  id\n                }\n                ... on Tag {\n                  id\n                }\n              }\n              id\n            }\n          }\n          filter {\n            keys\n            filter {\n              key\n              ids\n            }\n          }\n        }\n        previews {\n          count\n          edges {\n            cursor\n            preview {\n              mediaAsset {\n                files {\n                  id\n                  name\n                  path\n                }\n                topLevelMediaType {\n                  kind\n                  label\n                  id\n                }\n                id\n              }\n              link\n              kind\n            }\n          }\n        }\n        subTitle\n        title\n      }\n      ... on Node {\n        id\n      }\n    }\n  }\n}\n",
    "metadata": {}
  }
};
})();
(node as any).hash = '091a00426a04ab7ec4ceb136d56e638a';
export default node;
